import React, { useEffect } from "react";

const Toast = ({ message, isOpen, onClose, duration = 2500 }) => {
  useEffect(() => {
    if (!isOpen) return;
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [isOpen, duration, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed top-4 left-1/2 transform -translate-x-1/2 z-50">
      <div className="bg-indigo-600 text-white px-6 py-3 rounded-lg shadow-lg animate-fall-in">
        {message}
      </div>
    </div>
  );
};

export default Toast;
